import { render, staticRenderFns } from "./v-map-popup.vue?vue&type=template&id=060d7521&scoped=true&"
import script from "./v-map-popup.vue?vue&type=script&lang=js&"
export * from "./v-map-popup.vue?vue&type=script&lang=js&"
import style0 from "./v-map-popup.vue?vue&type=style&index=0&id=060d7521&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d7521",
  null
  
)

export default component.exports